import { toast } from 'sonner';

import { isPlanGateError, planFeatureRequired } from '@/shared/api/plan-errors';
import messages from '@/shared/i18n/en/billing';
import { tr } from '@/shared/i18n/translate';

/**
 * The global safety net for "your plan doesn't include this" (402
 * `plan_feature_required` from PlanFeatureGuard, or the Personal tier's
 * `upgrade_required`). Called by the MutationCache before the generic error
 * toast: such a failure is never shown as a raw error — one friendly toast
 * (deduplicated by id) with an "Upgrade plan" action to Billing. A mutation
 * that draws its own locked state (`silentErrors`) gets no toast at all.
 *
 * Returns true when the error was a plan gate (handled), false otherwise.
 */
export function handlePlanGateError(
  error: unknown,
  opts: { silent: boolean; openBilling: () => void },
): boolean {
  if (!isPlanGateError(error)) return false;
  if (opts.silent) return true;
  const team = planFeatureRequired(error) !== null;
  toast(tr(messages, team ? 'planRequiredTitle' : 'personalRequiredTitle'), {
    id: 'plan-required',
    description: tr(messages, team ? 'planRequiredBody' : 'personalRequiredBody'),
    action: { label: tr(messages, 'upgradePlan'), onClick: opts.openBilling },
  });
  return true;
}
